import React, { useEffect, useState } from "react";
import { Card, Input, Button, Flex, Checkbox } from "antd";
import { useCreateAllergyMutation } from "./allergy.service";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "./style.css";

const allergyType = [
  "celery",
  "gluten",
  "crustaceans",
  "eggs",
  "fish",
  "lupin",
  "milk",
  "molluscs",
  "mustard",
  "nuts",
  "peanuts",
  "sesame seeds",
  "soya",
  "sulphur dioxide",
];

export default function AllergyCreate() {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const [allergyUpdate, setAllergyUpdate] = useState([]);
  const [allergyDish, setAllergyDish] = useState("");

  const [requestCreateAllergy, { isSuccess }] = useCreateAllergyMutation();

  const handleCreateAllergy = () => {
    if (!allergyDish || allergyDish === "") {
      toast.error("type in dish");
      return;
    }

    requestCreateAllergy({
      name: allergyDish,
      allergens: allergyUpdate,
    });
  };

  useEffect(() => {
    if (isSuccess) {
      setAllergyUpdate([]);
      setAllergyDish("");
      toast.success(t("Allergy created successfully"));
      navigate("/allergy");
    }
  }, [isSuccess]);

  return (
    <Card
      title={`${t("ALLERGY")} ${t("CREATE")}`}
      className="allergy-create-page"
      extra={
        <Flex justify="center" gap={10}>
          <Button onClick={() => navigate("/allergy")}>{t("CANCEL")}</Button>
          <Button type="primary" onClick={handleCreateAllergy}>
            {t("SAVE")}
          </Button>
        </Flex>
      }
    >
      <div className="allergy-create-page-container">
        <div className="allergy-create-page-container-dish">
          <div>{t("DISH")}</div>
          <Input
            style={{ flex: "1" }}
            value={allergyDish}
            onChange={(e) => setAllergyDish(e.target.value)}
          />
        </div>
        <div className="allergy-create-page-container-allergy">
          <div className="allergy-create-page-container-allergy-label">
            {t("ALLERGY")}
          </div>
          <div className="allergy-create-page-container-allergy-grid">
            <div className="allergy-create-page-container-allergy-grid-item">
              {allergyType.slice(0, 7).map((item, key) => (
                <div
                  key={key}
                  className="allergy-create-page-container-allergy-grid-item"
                >
                  <Checkbox
                    checked={allergyUpdate.includes(item) ? true : false}
                    onClick={(cbox) => {
                      cbox.target.checked
                        ? setAllergyUpdate((e) => [...e, item])
                        : setAllergyUpdate((e) =>
                            e.filter((aItem) => aItem !== item)
                          );
                    }}
                  >
                    {t(item.toUpperCase())}
                  </Checkbox>
                </div>
              ))}
            </div>
            <div className="allergy-create-page-container-allergy-grid-item">
              {allergyType.slice(7, 14).map((item, key) => (
                <div
                  key={key}
                  className="allergy-create-page-container-allergy-grid-item"
                >
                  <Checkbox
                    checked={allergyUpdate.includes(item) ? true : false}
                    onClick={(cbox) =>
                      cbox.target.checked
                        ? setAllergyUpdate((e) => [...e, item])
                        : setAllergyUpdate((e) =>
                            e.filter((aItem) => aItem !== item)
                          )
                    }
                  >
                    {t(item.toUpperCase())}
                  </Checkbox>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="allergy-create-page-container-button">
          <Button type="primary" onClick={handleCreateAllergy}>
            {t("SAVE")}
          </Button>
        </div>
      </div>
    </Card>
  );
}
